module.exports = __webpack_public_path__ + "img/push.395535d5.png";